// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fixed-ratio-box_wrapper__07ANN","box":"fixed-ratio-box_box__7RKpn"};